export const EDIT_MODE = 'edit';
export const VIEW_MODE = 'view';
